"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
var react_1 = __importStar(require("react"));
var merge_1 = __importDefault(require("lodash/merge"));
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var mapValues_1 = __importDefault(require("lodash/mapValues"));
var i18n_1 = require("../i18n/i18n");
var LocaleContext_1 = __importDefault(require("../context/LocaleContext"));
var utils_1 = require("../utils");
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
};
function copyStaticProperties(base, target) {
    Object.keys(base).forEach(function (key) {
        if (!hoistBlackList[key]) {
            Object.defineProperty(target, key, 
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            Object.getOwnPropertyDescriptor(base, key));
        }
    });
}
// const cacheComponents = new WeakMap();
var cacheI18nInstance = {};
function withI18n(
// FIXME 处理被包裹函数的类型定义
WrappedComponent, params) {
    var _a = params || {}, _b = _a.forwardRef, forwardRef = _b === void 0 ? true : _b, _c = _a._noHoc, _noHoc = _c === void 0 ? false : _c, _d = _a.noMemo, noMemo = _d === void 0 ? false : _d, _e = _a.componentName, componentName = _e === void 0 ? "" : _e, _f = _a.no$i18nProps, no$i18nProps = _f === void 0 ? false : _f, locale = _a.locale;
    var baseComponentName = componentName || WrappedComponent.displayName || WrappedComponent.name;
    // 如果未指定componentName，则使用baseComponentName作为第二选择
    var primaryName = baseComponentName || (0, utils_1.getRandomKey)();
    // 只生成实例
    if (_noHoc && baseComponentName && locale) {
        (0, i18n_1.init)({
            locale: locale,
            componentName: baseComponentName,
        });
        return WrappedComponent;
    }
    function _inwrap(props) {
        var theContext = (0, react_1.useContext)(LocaleContext_1.default);
        // 二次memo，避免多次初始化
        var paramsLocale = locale;
        var contextLocale = theContext === null || theContext === void 0 ? void 0 : theContext.locale;
        // 获取上下文的指定的lang
        var contextLang = theContext === null || theContext === void 0 ? void 0 : theContext.lang;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        var propsLocale = props === null || props === void 0 ? void 0 : props.locale;
        var newI18n = (0, react_1.useMemo)(function () {
            if (cacheI18nInstance[primaryName]) {
                if ((0, isEqual_1.default)(cacheI18nInstance[primaryName].paramsLocale, paramsLocale) &&
                    (0, isEqual_1.default)(cacheI18nInstance[primaryName].contextLocale, contextLocale) &&
                    (0, isEqual_1.default)(cacheI18nInstance[primaryName].propsLocale, propsLocale) &&
                    (0, isEqual_1.default)(cacheI18nInstance[primaryName].contextLang, contextLang)) {
                    return {
                        $i18n: cacheI18nInstance[primaryName].$i18n,
                        locale: cacheI18nInstance[primaryName].locale,
                    };
                }
            }
            var propsLocaleCanHasNoNs = propsLocale && baseComponentName
                ? (0, mapValues_1.default)(propsLocale, function (item) {
                    var _a;
                    return item[baseComponentName]
                        ? item
                        : (_a = {}, _a[baseComponentName] = item, _a);
                })
                : propsLocale;
            // 入参 < 上下文 < 组件props
            var mergeLocale = (0, merge_1.default)({}, paramsLocale, contextLocale, propsLocaleCanHasNoNs);
            var _$i18n = (0, i18n_1.init)({
                locale: mergeLocale,
                componentName: baseComponentName,
                lang: contextLang,
            });
            cacheI18nInstance[primaryName] = {
                $i18n: _$i18n,
                paramsLocale: paramsLocale,
                contextLocale: contextLocale,
                propsLocale: propsLocale,
                contextLang: contextLang,
                locale: mergeLocale,
            };
            return {
                $i18n: _$i18n,
                locale: mergeLocale,
            };
        }, [paramsLocale, contextLocale, propsLocale, contextLang]);
        var providerValue = (0, react_1.useMemo)(function () {
            return { locale: newI18n.locale, $i18n: newI18n.$i18n };
        }, [newI18n.locale, newI18n.$i18n]);
        var theProps = no$i18nProps ? props : __assign(__assign({}, props), { $i18n: newI18n.$i18n });
        return { providerValue: providerValue, theProps: theProps };
    }
    var TheComponent = forwardRef === false
        ? function (props) {
            var _a = _inwrap(props), providerValue = _a.providerValue, theProps = _a.theProps;
            return (react_1.default.createElement(LocaleContext_1.default.Provider, { value: providerValue },
                react_1.default.createElement(WrappedComponent, __assign({}, theProps))));
        }
        : react_1.default.forwardRef(function (props, ref) {
            var _a = _inwrap(props), providerValue = _a.providerValue, theProps = _a.theProps;
            return (react_1.default.createElement(LocaleContext_1.default.Provider, { value: providerValue },
                react_1.default.createElement(WrappedComponent, __assign({}, theProps, { ref: ref }))));
        });
    if (!noMemo) {
        TheComponent = (0, react_1.memo)(TheComponent);
    }
    TheComponent.displayName = baseComponentName;
    copyStaticProperties(WrappedComponent, TheComponent);
    // cacheComponents.set(WrappedComponent, TheComponent);
    return TheComponent;
}
exports.default = withI18n;
